function updateModalCloseButton(modal) {
  modal.closeButton.html(
    '<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>'
  );
}

$(function () {
  // Image modal
  new jBox('Image', {
    addClass: 'modal-image__wrapper',
    id: 'image-modal',
    attach: '[data-article-image]',
    imageLabel: 'data-article-image',
    adjustDistance: {
      bottom: 64
    },
    onCreated: function () {
      updateModalCloseButton(this);
    }
  });

  // Video modal
  new jBox('Modal', {
    addClass: 'modal-video__wrapper',
    id: 'video-modal',
    attach: '[data-video]',
    width: '100%',
    height: '100%',
    adjustDistance: {
      top: 42,
      right: 0,
      bottom: 0,
      left: 0
    },
    onCloseComplete: function () {
      this.content.html('');
    },
    onCreated: function () {
      updateModalCloseButton(this);
    },
    onOpen: function () {
      var videoLink = this.source.attr('data-video');

      if (localStorage.getItem('googleYouTubeAccepted')) {
        loadVideo(videoLink, this.content);
      } else {
        var contentEl = this.content;

        var wrapper = $(
          '<div class="dsgvo__accept-wrapper dsgvo__accept-wrapper--video"/>'
        );
        wrapper.css({
          backgroundImage:
            'url("' + this.source.attr('data-video-thumbnail') + '")'
        });

        var container = $('<div class="dsgvo__accept-container"/>');
        container.appendTo(wrapper);

        var contentContainer = $('<div class="dsgvo__accept-content">');
        contentContainer.appendTo(container);

        var title = $('<div class="dsgvo__accept-title">');
        title.html('Video abspielen');
        title.appendTo(contentContainer);

        var text = $('<div class="dsgvo__accept-text">');
        text.html(
          'Wenn Sie auf "Video abspielen" klicken, wird eine Verbindung zu Google Inc. hergestellt. Dabei werden Daten an Google übertragen. Weitere Infos finden Sie auf unserer <a href="/datenschutz">Datenschutz Seite</a>.'
        );
        text.appendTo(contentContainer);

        var button = $('<div class="dsgvo__accept-button button">');
        button.html('Video abspielen');
        button.on('click', function () {
          acceptGoogleYouTube();
          $('.dsgvo__accept-wrapper--video').remove();
          loadVideo(videoLink, contentEl);
        });
        button.appendTo(contentContainer);

        this.content.html(wrapper);
      }
    }
  });

  // Map modal
  new jBox('Modal', {
    addClass: 'modal-map__wrapper',
    id: 'map-modal',
    attach: '[data-region-link]',
    width: '100%',
    height: '100%',
    adjustDistance: {
      top: 42,
      right: 0,
      bottom: 0,
      left: 0
    },
    onCloseComplete: function () {
      this.content.html('');
    },
    onCreated: function () {
      updateModalCloseButton(this);
    },
    onOpen: function () {
      var lat = this.source.attr('data-lat');
      var lng = this.source.attr('data-lng');
      var markers = [{ lat: lat, lng: lng }];

      if (localStorage.getItem('googleMapsAccepted')) {
        loadMap(this.content, markers);
      } else {
        createMapAcceptNotice(this.content, markers);
      }
    }
  });

    // Map modal
    new jBox('Modal', {
      id: 'contact-modal',
      title: 'Kontakt',
      attach: '[data-contact-modal]',
      width: 400,
      closeButton: 'title',
      onOpen: function () {
        var id = this.source.attr('data-contact-modal');
        this.setContent($('.list-item__contact-modal[data-id="' + id + '"]').clone());
      }
    });
});

function loadVideo(videoLink, contentEl) {
  contentEl.html(
    '<iframe width="100%" height="100%" src="' +
      videoLink +
      '?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
  );
}

function acceptGoogleYouTube() {
  localStorage.setItem('googleYouTubeAccepted', 1);
}
